import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AdaptiveCardSubmitData } from '@app/model/adaptive-card-submit-data';
import { ChatMessageModel } from '@app/model/chat-message.model';
import { SettingsService } from '@app/services/settings.service';
import { ChatMessageType, ImageModel } from 'library-explorer';

@Component({
    selector: 'app-chat-message',
    templateUrl: './chat-message.component.html',
    styleUrls: ['./chat-message.component.scss'],
    standalone: false
})
export class ChatMessageComponent implements OnChanges {

  @Input() public adapter: any;
  @Input() public currentUserMessage = false;
  @Input() public canDelete = false;
  @Input() public canEdit: boolean;
  @Input() public htmlMessage = false;
  @Input() public streamingTextAnimation: boolean;
  @Input() private readonly message: any;

  @Output() public mediaLoaded: EventEmitter<void> = new EventEmitter();
  @Output() public edit: EventEmitter<void> = new EventEmitter();
  @Output() public delete: EventEmitter<void> = new EventEmitter();
  @Output() public submitAction: EventEmitter<AdaptiveCardSubmitData> = new EventEmitter();

  public mappedMessage: ChatMessageModel;
  public messageTypes = ChatMessageType;
  public aiChatBotIcon: ImageModel;

  constructor(
    private readonly settingsService: SettingsService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.item || changes.adapter) && this.adapter && this.message) {
      this.mappedMessage = this.adapter.mapMessage(this.message);
      this.canEdit ??= this.currentUserMessage && !this.message.isFileMessage;
    }

    this.settingsService.getSettings().subscribe(settings => {
      this.aiChatBotIcon = settings.aiChatbot.assistantIcon;
    })
  }

  public deleteMessage(): void {
    this.delete.emit();
  }

  public editMessage(): void {
    this.edit.emit();
  }
}
